import { useEffect, useState } from "react";
import type { Locale } from "../shared/types";
import { AdminApp } from "./AdminApp";
import { GuestRsvp } from "./GuestRsvp";
import { PublicRegistration } from "./PublicRegistration";
import { Unsubscribe } from "./Unsubscribe";
import { Brand, LanguageSwitch, text } from "./ui";
import { initialLocale, saveLocale } from "./locale";

export function App() {
  const [locale, updateLocale] = useState<Locale>(initialLocale);
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);
  const setLocale = (value: Locale) => {
    saveLocale(value);
    updateLocale(value);
  };
  const path = window.location.pathname.replace(/\/$/, "") || "/";
  if (path === "/admin" || path.startsWith("/admin/")) return <AdminApp locale={locale} setLocale={setLocale} />;
  if (path === "/unsubscribe") return <Unsubscribe locale={locale} setLocale={setLocale} />;
  const registration = path.match(/^\/register\/([a-z0-9]+(?:-[a-z0-9]+)*)$/);
  if (registration) return <PublicRegistration eventSlug={registration[1]} locale={locale} setLocale={setLocale} />;
  const match = path.match(/^\/rsvp\/([^/]+)$/);
  if (match) return <GuestRsvp eventSlug={decodeURIComponent(match[1])} locale={locale} setLocale={setLocale} />;
  return (
    <div className="empty-page">
      <header><Brand /><LanguageSwitch locale={locale} onChange={setLocale} /></header>
      <main><span className="eyebrow">ECHOS EVENTS</span><h1>{text(locale, "Kişisel davet bağlantınızı kullanın.", "Please use your personal invitation link.")}</h1><p>{text(locale, "Davetinizle ilgili desteğe ihtiyacınız varsa bizimle iletişime geçin.", "Contact us if you need help with your invitation.")}</p><a className="primary-button" href="mailto:info@echosedu.com">info@echosedu.com <span>↗</span></a></main>
    </div>
  );
}
